export const formatDate = (dateString) => {
    const months = {
        'JAN': 'January',
        'FEB': 'February',
        'MAR': 'March',
        'APR': 'April',
        'MAY': 'May',
        'JUN': 'June',
        'JUL': 'July',
        'AUG': 'August',
        'SEP': 'September',
        'OCT': 'October',
        'NOV': 'November',
        'DEC': 'December'
    };
    const dateParts = dateString.split('-');
    const day = parseInt(dateParts[0], 10);
    const monthAbbreviation = dateParts[1].toUpperCase();
    const month = months[monthAbbreviation];
    const year = parseInt(dateParts[2], 10);
    const formattedDay = day + (day === 1 ? 'st' : day === 2 ? 'nd' : day === 3 ? 'rd' : day === 31 ? 'st' : 'th');
    return `${formattedDay} ${month}, ${year}`;
};
